import type { GraduationMode, Site, SiteApi } from '@/types/Site';
import { resolveDownloadSvg } from '@/utils/resolveBackendUrl';

const GRADUATION_MODES: GraduationMode[] = ['all', 'nonCertified', 'certified', 'auto'];

export class SiteMapper {
    private static siteProperties: Array<keyof SiteApi> = [
        'id',
        'name',
        'url',
        'urlCGV',
        'shopUrl',
        'languageList',
        'features',
        'translationUrl',
        'baseTexture',
        'configurationUrl',
        'sceneBackgroundColor',
        'screenshotBackgroundColor',
        'primaryColor',
        'secondaryColor',
        'uiColors',
        'exportPSD',
        'shouldShowUploadLogoModal',
        'logo',
        'logoMobile',
        'options'
    ];

    static getSiteFromData(siteData: SiteApi): Site {
        SiteMapper.checkSiteData(siteData);
        const {
            id,
            name,
            url,
            urlCGV,
            shopUrl,
            languageList,
            features,
            baseTexture,
            translationUrl,
            configurationUrl,
            sceneBackgroundColor,
            screenshotBackgroundColor,
            primaryColor,
            secondaryColor,
            uiColors,
            vdpGuide,
            exportPSD,
            shouldShowUploadLogoModal,
            logo,
            logoMobile,
            options,
            isSupportEnabled,
            graduationMode
        } = siteData;

        const site: Site = {
            id: id || '',
            name: name || '',
            siteUrl: url || '',
            tosUrl: urlCGV || '',
            shopUrl: shopUrl || '',
            languageList: languageList || [],
            features: features || [],
            baseTextureUrl: baseTexture || '',
            translationUrl: translationUrl || '',
            configurationUrl: configurationUrl || '',
            sceneBackgroundColor: sceneBackgroundColor || '',
            screenshotBackgroundColor: screenshotBackgroundColor || '',
            primaryColor: primaryColor || '',
            secondaryColor: secondaryColor || '',
            uiColors: uiColors && typeof uiColors === 'object' ? uiColors : null,
            vdpGuide: vdpGuide && typeof vdpGuide === 'object' ? vdpGuide : null,
            exportMode: exportPSD || false,
            shouldShowUploadLogoModal: shouldShowUploadLogoModal || false,
            logoDesktopUrl: resolveDownloadSvg(logo) || '',
            logoMobileUrl: resolveDownloadSvg(logoMobile) || '',
            options: options || [],
            isSupportEnabled: isSupportEnabled ?? false,
            graduationMode: GRADUATION_MODES.includes(graduationMode as GraduationMode)
                ? (graduationMode as GraduationMode)
                : 'auto'
        };

        return site;
    }

    private static checkSiteData(siteData: SiteApi): void {
        SiteMapper.siteProperties.forEach((property) => {
            if (siteData[property] == null) {
                // Propriete optionnelle absente = cas normal : debug, pas error
                // (evite de polluer la console avec des "erreurs" sans gravite).
                console.debug(`Property ${property} is missing or undefined in this site: ${siteData.id}.`);
            }
        });
    }
}
